import moment from 'moment'

/**
 * formatDate
 * @param {String} date
 * @param {String} format
 * @return {string}
 */
export function formatDate (date, format = 'DD MMMM YYYY HH:mm') {
  return moment(date).format(format)
}
